import { TravelApiInterface } from "@syadem/kairos-citizen-js";
import { ActionResult } from "../../actionResult";
import { Service } from "../service";

interface Payload {
  healthRecordId: string;
  travelId: string;
}

export class DeleteTravelService implements Service<Payload, void> {
  constructor(private readonly travelApi: TravelApiInterface) {}

  async call({ healthRecordId, travelId }: Payload): Promise<ActionResult<void>> {
    await this.travelApi.deleteTravel(healthRecordId, travelId);

    return {
      type: "success",
      value: undefined,
    };
  }
}
